import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-view-image',
    templateUrl: './view-image.component.html',
    styleUrls: ['./view-image.component.scss']
})
export class ViewImageComponent {
    rotateDegrees: number = 0;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<ViewImageComponent>,
    ) { }

    closeDialog() {
        this.dialogRef?.close();
    }

    get rotateClass(): string {
        return `rotate(${this.rotateDegrees}deg)`;
    }

    rotateImage(): void {
        this.rotateDegrees += 90;
        this.rotateDegrees = this.rotateDegrees % 360;
    }

    // downloadImage() {

    // }
}
